import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-all-equipment-addendum',
  templateUrl: './view-all-equipment-addendum.component.html',
  styleUrls: ['./view-all-equipment-addendum.component.scss']
})
export class ViewAllEquipmentAddendumComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
